import React, { Suspense } from 'react';
import PageLoader from '../components/PageLoader';

const Loadable =
  <T extends React.ComponentType<any>>(Component: React.LazyExoticComponent<T>) =>
  (props: React.ComponentProps<T>) =>
    (
      <Suspense fallback={<PageLoader />}>
        <Component {...props} />
      </Suspense>
    );

export default Loadable;
